import { render, staticRenderFns } from "./section1.vue?vue&type=template&id=1b76d5c5&scoped=true&"
import script from "./section1.vue?vue&type=script&lang=js&"
export * from "./section1.vue?vue&type=script&lang=js&"
import style0 from "./section1.vue?vue&type=style&index=0&id=1b76d5c5&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b76d5c5",
  null
  
)

export default component.exports